var React = require('react');

function AdidasPerformance (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n      fill: currentColor;\n      }\n    ")),React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1","key":1},React.createElement("path",{"className":"cls-1","d":"m270.3,228.99L161.69,40.87,232.47,0l132.21,228.99h-94.38Zm-31.52,0l-87.25-151.12-70.78,40.87,63.65,110.25h94.38Zm-125.8,0l-42.2-73.09L0,196.77l18.6,32.22h94.38Z"}))]);
}

AdidasPerformance.defaultProps = {"id":"Layer_2","data-name":"Layer 2","viewBox":"0 0 364.68 228.99"};

module.exports = AdidasPerformance;

AdidasPerformance.default = AdidasPerformance;
